import axiosInstance from '@/utils/httpUtil'
import { setting } from '@/setting'

const adminBaseUrl = setting.adminBaseUrl

export const userApi = {
  // 创建求职者账号
  createJobSeekerAccount: (accountData) => {
    return axiosInstance.post(
      `${adminBaseUrl}/account/jobSeeker`,
      {
        name: accountData.name,
        account: accountData.account,
        password: accountData.password,
        email: accountData.email,
        phone: accountData.phone,
        channelId: accountData.channelId,
        enabledTime: accountData.enabledTime,
        expiredTime: accountData.expiredTime
      }
    )
  },

  // 创建教练账号
  createCoachAccount: (accountData) => {
    return axiosInstance.post(
      `${adminBaseUrl}/account/coach`,
      {
        name: accountData.name,
        account: accountData.account,
        password: accountData.password,
        email: accountData.email,
        enabledTime: accountData.enabledTime,
        expiredTime: accountData.expiredTime
      }
    )
  },

  // 创建管理员账号
  createAdminAccount: (accountData) => {
    return axiosInstance.post(
      `${adminBaseUrl}/account/admin`,
      {
        name: accountData.name,
        account: accountData.account,
        password: accountData.password,
        email: accountData.email,
        enabledTime: accountData.enabledTime,
        expiredTime: accountData.expiredTime
      }
    )
  },

  // 获取用户来源渠道列表
  getUserSourceChannels: () => {
    return axiosInstance.get(
      `${adminBaseUrl}/channel/userSources`
    )
  },

  // 获取求职者账号列表
  getJobSeekerAccounts: () => {
    return axiosInstance.get(
      `${adminBaseUrl}/account/jobSeeker`
    )
  },
  // 获取账号状态列表
  getAccountStatusList() {
    return axiosInstance.get(
        `${adminBaseUrl}/account/status`
    )
  },

  // 修改求职者账号密码
  updateJobSeekerPassword: (userId, newPassword) => {
    return axiosInstance.put(
      `${adminBaseUrl}/account/jobSeeker/password`,
      {
        userId,
        newPassword
      }
    )
  },

  // 更新求职者账号信息
  updateJobSeekerAccount: (accountData) => {
    return axiosInstance.put(
      `${adminBaseUrl}/account/jobSeeker`,
      {
        account: accountData.username,
        name: accountData.name,
        email: accountData.email,
        phone: accountData.phone,
        channelId: accountData.sourceChannelId,
        enabledTime: accountData.startTime,
        expiredTime: accountData.expiredTime,
        accountStatusId: accountData.accountStatus.id
      }
    )
  },

  // 停用求职者账号
  disableJobSeekerAccount: (accountId) => {
    return axiosInstance.delete(
      `${adminBaseUrl}/account/jobSeeker/${accountId}`
    )
  },

  // 获取求职者列表
  getCandidateList: (page, pageSize) => {

    return axiosInstance.get(
      `${adminBaseUrl}/candidate/?page=${page}&pageSize=${pageSize}`
    )
  },

  // 获取求职者课程分类权限
  getJobSeekerPermissions: (userId) => {
    return axiosInstance.get(
      `${adminBaseUrl}/account/jobSeeker/${userId}/permission/courseCategory`
    )
  },

  // 更新求职者课程分类权限
  updateJobSeekerPermissions: (userId, addIds, removeIds) => {
    return axiosInstance.post(
      `${adminBaseUrl}/account/jobSeeker/${userId}/permission/courseCategory`,
      {
        addCategoriesIds: addIds,
        removeCategoriesIds: removeIds
      }
    )
  },

  // 获取求职者详情
  getCandidateDetail: (candidateId) => {
    return axiosInstance.get(
      `${adminBaseUrl}/candidate/${candidateId}`
    )
  }
}